import Box from '@mui/material/Box'
import { styled } from '@mui/system'
import Paper from '@mui/material/Paper'
import Popper from '@mui/material/Popper'
import { alpha, IconButton } from '@mui/material'

interface UserActionsBoxProps {
	readonly open?: boolean
}

const UserActionsBox = styled(Box)<UserActionsBoxProps>(({ theme, open }) => ({
	width: '3rem',
	minWidth: '3rem',
	maxWidth: '3rem',
	borderRadius: '0.625rem',
	padding: '0.55rem 0.7rem 0.5rem 0.5rem',
	backgroundColor: open ? alpha(theme.palette.common.white, 0.1) : 'unset',
	marginLeft: '0.25rem',
	display: 'flex',
	alignItems: 'center',
}))

const UserActionsButton = styled(IconButton)(({ theme }) => ({
	color: theme.palette.common.white,
	border: `0.125rem solid ${theme.palette.common.white}`,
	padding: '0.25rem',
	minWidth: '2rem',
	maxWidth: '2rem',
	width: '2rem',
	height: '2rem',
}))

const UserActionsPopper = styled(Popper)(({ theme }) => ({
	'&.popper': {
		filter: 'drop-shadow(0px 3px 30px rgba(53, 61, 69, 0.2))',
		borderRadius: '16px',
		zIndex: 5000,
		width: '16rem',
		'.MuiPaper-rounded': {
			borderRadius: '16px',
		},
		'&[data-popper-placement="right-end"] .arrow': {
			top: 'unset !important',
			display: 'block',
			marginTop: '-0.85em',
			width: '3em',
			height: '1em',
			'&::before': {
				content: '""',
				display: 'block',
				transform: 'translate(-100%, 50%) rotate(270deg)',
				borderWidth: '0 1em 1em 1em',
				borderColor: `transparent transparent ${theme.palette.background.paper} transparent`,
			},
		},
	},
	'& .arrow': {
		position: 'absolute',
		fontSize: '1.8rem',
		width: '3em',
		height: '3em',
		'&::before': {
			content: '""',
			margin: 'auto',
			display: 'block',
			width: 0,
			height: 0,
			borderStyle: 'solid',
		},
	},
}))

const UserActionsList = styled(Paper)(({ theme }) => ({
	padding: '0.75rem',
	display: 'flex',
	flexDirection: 'column',
	border: `0.0625rem solid ${theme.palette.grey[200]}`,
}))

const UsersActionsDivider = styled('hr')(({ theme }) => ({
	border: 'none',
	height: '0.0625rem',
	maxHeight: '0.0625rem',
	backgroundColor: theme.palette.grey[200],
	width: 'auto',
	margin: '0.75rem 1.25rem',
}))

export {
	UserActionsBox,
	UserActionsButton,
	UserActionsPopper,
	UserActionsList,
	UsersActionsDivider,
}
